import Waivers from './Waivers'
import DamageWaiver from './DamageWaiver'
import ProtectionWaiver from './ProtectionWaiver'
export { AvailabilityIcons } from 'components/IconIndicator'

export default Object.assign(Waivers, {
  Damage: DamageWaiver,
  Protection: ProtectionWaiver,
})
